module.exports = __webpack_public_path__ + "img/introduction02_contact_01.5dfaedd0.png";